import { render, staticRenderFns } from "./ArticlesOverview.vue?vue&type=template&id=19a4e704&scoped=true"
import script from "./ArticlesOverview.vue?vue&type=script&lang=js"
export * from "./ArticlesOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a4e704",
  null
  
)

export default component.exports